export default "<p >©St. Xavier's High School | xaviers@edu.in   |   7978120295</p>\n"